exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spec-table[data-v-6275e6c9]{width:100%}.spec-table td[data-v-6275e6c9]{padding:3px}.list p[data-v-6275e6c9]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0}.list[data-v-6275e6c9]:nth-child(2n){background:#f7f7f7}\n", ""]);

// exports
